import { render, staticRenderFns } from "./my-motions-details-component.vue?vue&type=template&id=763f247c&scoped=true"
import script from "./my-motions-details-component.ts?vue&type=script&lang=ts&external"
export * from "./my-motions-details-component.ts?vue&type=script&lang=ts&external"
import style0 from "./my-motions-details-component.scss?vue&type=style&index=0&id=763f247c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f247c",
  null
  
)

export default component.exports